import React from "react";

const upD =
  "M9.00008 3.41421L1.70718 10.7071L0.292969 9.29289L9.00008 0.585785L17.7072 9.29289L16.293 10.7071L9.00008 3.41421Z";
const downD =
  "M16.293 0.292908L17.7072 1.70712L9.00008 10.4142L0.292969 1.70712L1.70718 0.292908L9.00008 7.5858L16.293 0.292908Z";
const leftD =
  "M3.41436 9.00001L10.7073 16.2929L9.29304 17.7071L0.585938 9.00001L9.29304 0.292908L10.7073 1.70712L3.41436 9.00001Z";
const rightD =
  "M7.58586 9.00001L0.292969 1.70712L1.70718 0.292908L10.4143 9.00001L1.70718 17.7071L0.292969 16.2929L7.58586 9.00001Z";

const getDirectionPath = (direction) => {
  return (
    {
      up: upD,
      down: downD,
      left: leftD,
      right: rightD,
    }[direction] || downD
  );
};

/**
 * Chevron icon component
 * @param {Object} props - Component props
 * @param {string} [props.color='black'] - Color of the chevron
 * @param {('up'|'down'|'left'|'right')} [props.direction='down'] - Direction of the chevron
 * @param {number} [props.size=18] - Size of the chevron
 * @param {boolean} [props.small=false] - Whether to use small variant
 * @param {string} [props.viewBox=null] - Custom viewBox value
 * @param {string} [props.className=''] - Additional CSS class names
 * @returns {React.ReactElement} ChevronIcon component
 */
export const ChevronIcon = ({
  color = "black",
  direction = "down",
  size = 18,
  small = false,
  viewBox = null,
  className = "",
  ...rest
}) => {
  if (!viewBox) viewBox = small ? "0 -2 22 22" : "0 0 18 18";

  const pathD = getDirectionPath(direction);

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path fillRule="evenodd" clipRule="evenodd" d={pathD} fill={color} />
    </svg>
  );
};
